import { combineReducers } from "redux";
import token from "./token";
import counts from "./counts";

export default combineReducers({ token, counts});